import Link from "next/link";
import { useRouter } from "next/router";
import { FC, ReactElement } from "react";

export interface SideBarLinkProps {
    Icon?:
        | React.ForwardRefExoticComponent<
              Omit<React.SVGProps<SVGSVGElement>, "ref"> & {
                  title?: string | undefined;
                  titleId?: string | undefined;
              } & React.RefAttributes<SVGSVGElement>
          >
        | (({ className }: { className: string }) => ReactElement);
    location: string;
    label: string;
    onClick?: () => void;
    iconSize?: string;
    isBeta?: boolean;
}

const SidebarLink: FC<SideBarLinkProps> = ({
    Icon,
    location,
    label,
    onClick,
    iconSize,
    isBeta,
}) => {
    const router = useRouter();
    const isActive =
        location === "/"
            ? router.pathname === location
            : router.pathname.startsWith(location);

    return (
        <Link href={location} onClick={onClick}>
            <div
                className={` ${isActive ? "text-primary" : "text-text-detail"} group/link relative flex items-center gap-4 rounded-lg px-4 py-2.5 transition-all hover:bg-secondary-gray-2`}
            >
                {Icon ? (
                    <Icon
                        className={`stroke-0 group-hover/link:animate-wiggle ${iconSize ?? "size-6"} `}
                    />
                ) : null}
                <div className="relative">
                    <span className="text-base">{label}</span>
                    {isBeta && (
                        <span className="absolute -right-2 top-0 translate-x-full text-xs text-primary-yellow">
                            Beta
                        </span>
                    )}
                </div>
            </div>
        </Link>
    );
};

export default SidebarLink;
